module.exports = __webpack_public_path__ + "img/Argentina12.c7a43b2f.png";